import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Services } from '../components/Services';
import { Gallery } from '../components/Gallery';
import { WhyUs } from '../components/WhyUs';
import { Contact } from '../components/Contact';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="w-full min-h-screen bg-[#0d1117] text-white" data-id="element-170">
      <Navbar data-id="element-171" />
      <Hero data-id="element-172" />
      <Services data-id="element-173" />
      <Gallery data-id="element-174" />
      <WhyUs data-id="element-175" />
      <Contact data-id="element-176" />
      <Footer data-id="element-177" />
    </div>;
}